import type { DepositClosableNotification, NotificationMember } from '../@types/notifications';

export const isDepositClosableNotification = <TType extends DepositClosableNotification['key']>(
  notification: { key: string },
  ...expectedTypes: TType[]
): notification is NotificationMember<TType> => {
  return expectedTypes.includes(notification.key as TType);
};
